import {TFunction} from "react-i18next";
import {ITenantColumn} from "../components/OnixElements";
import {hr} from "../locales/hr";

type MakeTenantColumnsParams<T> = {
    [key in keyof (Partial<T> & { [key: string]: any })]: {
        render?: (item: T) => JSX.Element;
        minWidth?: number;
        maxWidth?: number;
        translation?: keyof typeof hr | string;
    };
};

export const MakeTenantColumns = <T>(
    obj: MakeTenantColumnsParams<T>,
    t: TFunction,
    baseMinWidth?: number,
): ITenantColumn<T>[] => {
    return Object.keys(obj).map((m: string) => {
        let {render, minWidth, maxWidth, translation} = obj[m as keyof T];
        if (!minWidth) minWidth = baseMinWidth;
        return {
            minWidth: minWidth ?? 100,
            maxWidth: maxWidth == -1 ? undefined : (maxWidth ?? minWidth ?? 100),
            fieldName: m,
            key: m,
            onRender: render,
            name: t(translation ?? m),
        };
    });
};
